import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent, AlertController } from '@ionic/angular';  // renamed from Content

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { SiteStructure } from 'src/app/services/global/structure';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';

@Component({
  selector: 'myeventsite',   // <<< NOTE manually changed from "app-myeventsite"
  templateUrl: './myeventsite.component.html',
  styleUrls: ['./myeventsite.component.scss'],
})
export class MyeventsiteComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  @Output() outEventSite: EventEmitter<any> = new EventEmitter<any>();
  @Output() outEventSiteListRefreshed: EventEmitter<any> = new EventEmitter<any>();

  private consoleLog:boolean = false;

  public EventSites:any;
  public FormattedAddress:string;
  public LocationChoiceTypeCode:string;
  public LocationPrompt:string = 'Site';
  public LocationSubPrompt:string = 'Select Onsite/Offsite';

  public dotGpsUrl:string = "assets/imgs/dotGps.png";
  public dotIpsUrl:string = "assets/imgs/dotIps.png";


  private NearestGeofenceSite:SiteStructure = new SiteStructure();
  private nearestSite:SiteStructure = new SiteStructure();
  public OffSite:SiteStructure = new SiteStructure();
  public SelectedItem:SiteStructure = null; // new SiteStructure(); // this.Model.SelectedResponse.Item = item;
  //public Model.StructuredResponseId = item.id;
  public showList:boolean = true;
  public showDetails:boolean = false;

  constructor(
      private alertController: AlertController
    , public apiProvider: ApiService
    , public commonProvider: CommonService
    , public globalProvider: GlobalService
    , private geolocationProvider: GeolocationWrapperService
    , public translate: TranslateService
    , public zone: NgZone
    , public events: Events
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_myeventsite;
    if (this.consoleLog) console.log('myeventsite.ctor - LifeCycle');
    this.Initialize("ctor");
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() // ngAfterViewInit()
  {
    if (this.consoleLog) console.log('myeventsite.ngOnInit - ' + this.pageName + ' - LifeCycle');
    this.Initialize("ngOnInit");
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('myeventsite.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
  }

  // ----------------------------------------------------
  // --------------  INITIALIZE   -----------------------
  // ----------------------------------------------------
  public Initialize(context:string)
  {
    if (this.consoleLog) console.log('myeventsite.Initialize');
    this.InitializeOffSiteLocation();
    this.CallGetSiteInfoList();
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }


  InitializeOffSiteLocation()
  {
    if (this.consoleLog) console.log('myeventsite.InitializeOffSiteLocation');
    let approximateAddress = 'Approx address based on Geolocation will be used';
    if (this.FormattedAddress)
    {
      approximateAddress = this.myTranslate(this.FormattedAddress);
    }

    // Add the default items to the list first

    this.OffSite = new SiteStructure();
    this.OffSite.SiteId = -1;
    this.OffSite.SiteCode = this.myTranslate('OFFSITE');
    this.OffSite.SiteName = this.myTranslate('Offsite');
    this.OffSite.DisplaySiteName = this.myTranslate('Use my coordinates');
    this.OffSite.FormattedAddress = approximateAddress;
    this.OffSite.HealthRiskFlag = false;
    this.OffSite.FloorPlanFlag = false;
    this.OffSite.MultiFloorFlag = false;
    this.OffSite.IndoorFlag = false;
    this.OffSite.DisplayGroup = this.myTranslate('I AM OFFSITE');
    this.OffSite.LocationChoiceTypeCode = 'USE_MOBILE_LOCATION';

    this.OffSite.SiteDistanceMeters = null;
    this.OffSite.SiteDistanceMiles = null;
    this.OffSite.SiteDistanceMilesDisplay = "";
    //= this.commonProvider.GetSiteDistanceValue(this.OffSite.SiteDistanceMiles
    //                                          , true
    //                                          , this.globalProvider.UserAppConfig.MetricUnitsFlag);

    this.OffSite.GeofenceRadiusMeters = null;
    this.OffSite.GeofenceRadiusMiles = null;
    this.OffSite.IsDistanceWithinGeoFence = false;

    this.OffSite.GpsLongitudeDecimal = this.geolocationProvider.GetPositionLongitude();
    this.OffSite.GpsLatitudeDecimal = this.geolocationProvider.GetPositionLatitude();

    this.OffSite.MobileUsersActiveCount = 0;
    this.OffSite.SiteGroupId = 0;
    this.OffSite.SiteGroupCode = "";
    this.OffSite.SiteGroupName = "";

    /*
    if (this.globalProvider.UserAppConfig.AutoSelectOffSite === true)
    {
      this.LocationChoiceTypeCode = this.OffSite.LocationChoiceTypeCode;
      this.SelectedItem = this.OffSite;
      this.SetSelectionAndNotify(this.OffSite);
    }
    else if (this.globalProvider.UserAppConfig.AutoSelectOnSite === true)
    {
      // only select the site if we are within its geofence (which we don't know yet)
      this.LocationChoiceTypeCode = 'USE_SITE_LOCATION';
      this.SelectedItem = null;
      this.SetSelectionAndNotify(this.SelectedItem);
    }
    */
  }


  // ----------------------------------------------------
  // --------------- ON-OFF SITE BUTTONS      -----------
  // ----------------------------------------------------

  btnLocationChoiceType($event:any)
  {
    console.log("myeventsite.btnLocationChoiceType: INCOMING:", $event);
    // console.log("myeventsite.btnLocationChoiceType:" + $event['detail']['value'], $event);

    var LocationChoiceTypeCode:string = $event.detail.value;
    console.log("myeventsite.btnLocationChoiceType: to " + LocationChoiceTypeCode + " from " + this.LocationChoiceTypeCode);

    if (LocationChoiceTypeCode === 'USE_MOBILE_LOCATION')
    {
      this.SelectedItem = this.OffSite;
    }
    else if (LocationChoiceTypeCode === 'USE_SITE_LOCATION')
    {
      // clear the selection (if any) to force a selection from the site list
      this.SelectedItem = null;
    }
    
    // now save the location type selection and notify
    this.LocationChoiceTypeCode = LocationChoiceTypeCode;
    this.SetSelectionAndNotify(this.SelectedItem);
  }

  SetSelectionAndNotify(selectedItem:SiteStructure)
  {
    if (this.consoleLog) console.log("myeventsite.SetSelectionAndNotify", selectedItem);
    // note that:
    // -1 indicates an Offsite
    // >0 indicates a real site 
    // Null is no selection made yet (or selection undone)

    this.SelectedItem = selectedItem;
    this.SetDivElementDisplay();
    this.NotifyParentsOfSelection();
  }

  public GetNearestSite():SiteStructure
  {
    if (this.consoleLog) console.log("myeventsite.GetNearestSite", this.nearestSite);
    return this.nearestSite;
  }

  public GetNearestGeofenceSite():SiteStructure
  {
    if (this.consoleLog) console.log("myeventsite.NearestGeofenceSite", this.NearestGeofenceSite);
    return this.NearestGeofenceSite;
  }

  SetDivElementDisplay()
  {
    if (this.SelectedItem)
    {
      if (this.consoleLog) console.log("myeventsite.SetSelectionAndNotify: SELECTED", this.SelectedItem);
      this.showList = false;
      this.showDetails = true;
    }
    else  // deselected
    {
      if (this.consoleLog) console.log("myeventsite.SetSelectionAndNotify: DE-SELECTED", this.SelectedItem);
      this.showList = true;
      this.showDetails = false;
    }
  }

  public GetSelectedItem():SiteStructure
  {
    return this.SelectedItem;
  }

  NotifyParentsOfSelection()
  {
    if (this.consoleLog) console.log("myeventsite.NotifyParentsOfSelection", this.SelectedItem);
    if ((this.SelectedItem) && (this.SelectedItem.SiteId !== 0))
    {
      this.outEventSite.emit(this.SelectedItem);
    }
    else
    {
      this.outEventSite.emit(null);  // no selection made yet
    }
  }


  NotifyParentsOfRefreshedList()
  {
    if (this.consoleLog) console.log("myeventsite.NotifyParentsOfRefreshedList");

    if ((this.NearestGeofenceSite) && (this.NearestGeofenceSite.SiteId !== 0))
    {
      if (this.consoleLog) console.log("myeventsite.NotifyParentsOfRefreshedList - NearestGeofenceSite", this.NearestGeofenceSite);
      this.outEventSiteListRefreshed.emit(this.NearestGeofenceSite); // the actual data being sent is more of an FYI
      return;
    }

    if ((this.nearestSite) && (this.nearestSite.SiteId !== 0))
    {
      if (this.consoleLog) console.log("myeventsite.NotifyParentsOfRefreshedList - nearestSite", this.nearestSite);
      this.outEventSiteListRefreshed.emit(this.nearestSite); // the actual data being sent is more of an FYI
      return;
    }

    if (this.consoleLog) console.log("myeventsite.NotifyParentsOfRefreshedList - OffSite", this.OffSite);
    this.outEventSiteListRefreshed.emit(this.OffSite); // the actual data being sent is more of an FYI
}

  // ----------------------------------------------------
  // =========== OPTION SELECTION FROM LIST =============
  // ----------------------------------------------------

  btnItemDeselected(event, item:SiteStructure)
  {
    if (this.consoleLog) console.log('myeventsite.btnItemDeselected', item);

    if ((!item) || (item.LocationChoiceTypeCode === "USE_MOBILE_LOCATION"))
    {
      // deselect the locationtype as well...
      this.LocationChoiceTypeCode = null;
    }

    this.SetSelectionAndNotify(null);
  }

  btnItemSelected(event, item:SiteStructure) 
  {
    if (this.consoleLog) console.log('myeventsite.btnItemSelected', item);

    if (item.IsDistanceWithinGeoFence)
    {
      this.SetSelectionAndNotify(item);
    }
    else
    {
      this.AlertConfirmBeyondSiteGeofence(item);
    }
  }


  async AlertConfirmBeyondSiteGeofence(item:SiteStructure) 
  {
    // if (this.consoleLog) 
    console.log("myeventsite.AlertConfirmBeyondSiteGeofence" + " - Page:" + this.pageName, item);

    const alert = await this.alertController.create(
      { header: item.SiteName 
      , subHeader: this.myTranslate('Distance in Miles: ') + item.SiteDistanceMiles
      , message: this.myTranslate('Please confirm selected Site or cancel to change selection')
      , buttons: [
        { text: this.myTranslate('Cancel')
        , handler: () => 
          { 
            console.log('AlertConfirmBeyondSiteGeofence canceled'); 
          }
        }
        ,
        { text: this.myTranslate('Confirm')
        //, role: 'cancel'
        , handler: () => 
          { 
            console.log('ValidationAlert OK clicked'); 
            this.SetSelectionAndNotify(item);
          }
        }
      ]
    });
    await alert.present(); 
  }



  // ----------------------------------------------------
  // --------------- API FUNCTION CALLS       -----------
  // ----------------------------------------------------

  CallGetSiteInfoList()
  {
    if (this.consoleLog) console.log('ActionsCheckins.CallGetSiteInfoList');

    this.apiProvider.GetSiteInfoList(false) // do not ignore empty sites with no personnel 
    .then(data => { 
      this.zone.run(() => {
        //this.SetApiCallInfo(data);
        this.PopulateSiteListFromApiResponse(data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        //this.myloadingComponent.SetPageLoading(this.pageName, 9, errorMessage); //  this.SetPageLoading(9, errorMessage); 
        //this.SetApiCallInfo(errorMessage);
        console.warn("error", errorMessage);
        alert("Unable to read Site list");
      });
    });
  }

  PopulateSiteListFromApiResponse(apiResponse)
  {
    if (this.consoleLog) console.log('MyEventSite.PopulateSiteListFromApiResponse', apiResponse);

    //this.CheckinSites = 
    //  [ { Id: 12, name:'my current location', DisplayGroup:'My current location', LocationChoiceTypeCode:'USE_MOBILE_LOCATION'}
    //  , { Id: 14, name:'my home site location', DisplayGroup:'My home site', LocationChoiceTypeCode:'USE_SITE_LOCATION'}
    //  , { Id: 16, name:'Maxxess Red', DisplayGroup:'Other Sites', LocationChoiceTypeCode:'USE_SITE_LOCATION'}
    //  , { Id: 22, name:'Maxxess Blue', DisplayGroup:'Other Sites', LocationChoiceTypeCode:'USE_SITE_LOCATION'}
    //  , { Id: 42, name:'Office Yellow', DisplayGroup:'Other Sites', LocationChoiceTypeCode:'USE_SITE_LOCATION'}
    //  ];
    //this.myCheckinSite = this.CheckinSites[0]; // 

    // Add the list of Site to the combo box
    //let data = apiResponse.SiteLocationList;  
    let data = apiResponse.ViewModel;

    try
    {
      data.sort(function(b, a) {
          return parseFloat(a.SiteDistanceMiles) - parseFloat(b.SiteDistanceMiles);
      });
    }
    catch (error) 
    {
      console.warn("PopulateSiteListFromApiResponse: sort error");
    }

    this.EventSites = [];

// tslint:disable-next-line: forin
    for (let i in data)
    { 
      let Site = new SiteStructure();
      Site.SiteId = data[i].SiteId;
      Site.SiteCode = data[i].SiteCode;
      Site.SiteName = data[i].SiteName;
      Site.DisplaySiteName = data[i].SiteName;
      Site.FormattedAddress = data[i].FormattedAddress;
      Site.HealthRiskFlag = data[i].HealthRiskFlag;
      Site.FloorPlanFlag = data[i].FloorPlanFlag;
      Site.MultiFloorFlag = data[i].MultiFloorFlag;
      Site.IndoorFlag = data[i].IndoorFlag;
      if (Site.IndoorFlag === true) { Site.DisplaySiteName += " * "; }

      Site.DisplayGroup = this.myTranslate('KNOWN SITES');
      Site.LocationChoiceTypeCode = 'USE_SITE_LOCATION';

      // NOTE:  the API automatically computes the SiteDistance in both miles & meters (no need to convert between)
      Site.SiteDistanceMeters = data[i].SiteDistanceMeters;
      Site.SiteDistanceMiles = data[i].SiteDistanceMiles;
      Site.SiteDistanceMilesDisplay 
      = this.commonProvider.GetSiteDistanceValue( Site.SiteDistanceMiles
                                                , true
                                                , this.globalProvider.UserAppConfig.MetricUnitsFlag);

      // NOTE:  the API automatically computes the GeofenceRadius in both miles & meters (no need to convert between)
      Site.GeofenceRadiusMeters = data[i].GeofenceRadiusMeters;
      Site.GeofenceRadiusMiles = data[i].GeofenceRadiusMiles;

      Site.IsDistanceWithinGeoFence = false;
      if (Site.SiteDistanceMeters < Site.GeofenceRadiusMeters)
      {
        Site.IsDistanceWithinGeoFence = true;
        Site.DisplaySiteName += " [GF] ";
      }
      
      Site.GpsLongitudeDecimal = data[i].GpsLongitudeDecimal;
      Site.GpsLatitudeDecimal = data[i].GpsLatitudeDecimal;
      
      Site.MobileUsersActiveCount = data[i].MobileUsersActiveCount;
      Site.SiteGroupId = data[i].SiteGroupId;
      Site.SiteGroupCode = data[i].SiteGroupCode;
      Site.SiteGroupName = data[i].SiteGroupName;

      this.EventSites.unshift(Site); // add the site to the list

      // --------------------------------------------------------------------------------

      if ((this.nearestSite.SiteId === 0) || (this.nearestSite.SiteDistanceMiles > Site.SiteDistanceMiles))
      {
        this.nearestSite = Site;
        // this.globalProvider.SiteProximity.SetNearestSite(Site); // site proximity ONLY
      }

      // --------------------------------------------------------------------------------

      if (Site.IsDistanceWithinGeoFence === true)
      {
        if ((this.NearestGeofenceSite.SiteId === 0) || (this.NearestGeofenceSite.SiteDistanceMiles > Site.SiteDistanceMiles))
        {
          this.NearestGeofenceSite = Site;
          // this.globalProvider.SiteProximity.SetNearestGeofenceSite(Site); // geofence related and site proximity
        }
      }
    }

    this.NotifyParentsOfRefreshedList();
    this.SelectNearestOrShowList();
  }

  SelectNearestOrShowList()
  {
    if (this.consoleLog) console.log('MyEventSite.SelectNearestOrShowList', this.NearestGeofenceSite);

    if (this.globalProvider.UserAppConfig.AutoSelectEventSite === true)
    {
      if (this.NearestGeofenceSite.SiteId > 0)
      {
        this.LocationChoiceTypeCode = this.NearestGeofenceSite.LocationChoiceTypeCode;
        this.SetSelectionAndNotify(this.NearestGeofenceSite);
      }
      else
      {
        this.LocationChoiceTypeCode = 'USE_MOBILE_LOCATION';
        this.SetSelectionAndNotify(this.OffSite);
      }
    }
    else
    {
      if (this.NearestGeofenceSite.SiteId > 0)
      {
        // show nothing selected but do show the onsite list....
        this.LocationChoiceTypeCode = 'USE_SITE_LOCATION'; // show the site list
        this.SetSelectionAndNotify(null);
      }
      else
      {
        // show nothing selected and no list
        //this.LocationChoiceTypeCode = 'USE_MOBILE_LOCATION';
        this.LocationChoiceTypeCode = null;
        this.SetSelectionAndNotify(null);
      }
    }
  }

}
